import { HStack, Text, IconButton, Box } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { ClassesFiltersStudios } from './Studios';
import { ClassesFiltersCoaches } from './Coaches';
import { useClassFiltersStore } from '@stores/classes';
import { useMemo } from 'react';
import { getISOWeek, startOfWeek, endOfWeek, format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { CourseTypeFilter } from './CourseTypeFilter';
import { isCourseTypeFilterEnabled } from '../../courseTypeFilters';

export function ClassesFilters() {
  const date = useClassFiltersStore((state) => state.date);
  const setNextWeek = useClassFiltersStore((state) => state.setNextWeek);
  const setPreviousWeek = useClassFiltersStore((state) => state.setPreviousWeek);

  const isCurrentWeek = useMemo(() => getISOWeek(new Date()) === getISOWeek(date), [date]);

  const startDate = startOfWeek(date, { weekStartsOn: 1 }); // Définir le début de la semaine au lundi
  const endDate = endOfWeek(date, { weekStartsOn: 1 }); // Définir la fin de la semaine au dimanche

  const formattedDateRange = (
    <>
      {'semaine du'}
      <br />
      {`${format(startDate, 'd MMM', { locale: fr })} - ${format(endDate, 'd MMM yyyy', { locale: fr })}`}
    </>
  );

  return (
    <>
      <HStack
        width={{ base: '100%', md: '75%' }} // 100% sur mobile et 75% sur medium screens et plus
        direction={{ base: 'column', md: 'row' }}
        flexFlow={{ base: 'row wrap', md: 'initial' }}
      >
        <ClassesFiltersStudios />
        <ClassesFiltersCoaches />
        {isCourseTypeFilterEnabled() && <CourseTypeFilter />}
      </HStack>

      <HStack
        spacing={2}
        height="69px"
        alignItems="cenger"
        justifyContent="space-between"
        w="full"
        backgroundColor="#F5F5F5"
        position="relative"
        top="8px"
      >
        <Box width="400px" margin="auto" display="flex" alignItems="center" justifyItems="center">
          <IconButton
            aria-label="Previous"
            background="transparent"
            icon={<ChevronLeftIcon background="transparent" color="black" opacity={1} />}
            isDisabled={isCurrentWeek}
            onClick={setPreviousWeek}
          />
          <Text
            lineHeight="1.1"
            textAlign="center"
            maxWidth="180px"
            margin="auto"
            fontWeight="medium"
            size="md"
            className="weekName"
          >
            {formattedDateRange}
          </Text>
          <IconButton
            background="transparent"
            aria-label="Next"
            icon={<ChevronRightIcon background="transparent" color="black" opacity={1} />}
            onClick={setNextWeek}
          />
        </Box>
      </HStack>
    </>
  );
}
